/**
 * Textos centralizados de tooltips para evitar duplicación cross-componente.
 * El refactor 2026-05-20 (ventas_margenes_alineacion_banco) cambió la semantica
 * de "ventas" de "confirmadas en el mes" a "cobradas en el mes" — alineado con
 * extracto bancario. Los componentes que muestran KPI de ventas/revenue usan
 * este texto para explicar al usuario el cambio.
 */

export const TOOLTIP_VENTAS_COBRADAS =
  "Ventas cobradas en el mes (con IVA incluido, netas de descuentos y devoluciones): monto realmente entrado a banco, incluye pagos parciales. Las cuentas por cobrar pendientes se reflejan en el mes en que se cobren.";
